import { Card, message } from 'antd';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import {
  queryBudgetSetWorkflow,
  queryDeleteBudgetSet,
  querySaveBudgetSet,
} from '@api/finance/budget';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import FormOpen from './FormOpen';
import SubmitOp from './submitOp';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.setWorkflow();
  }

  /**
   * 提交设置
   */
  handSubmit = item => {
    this.saveSet(item);
  };

  setWorkflow = params => {
    const { instance } = this.state;
    queryBudgetSetWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveSet = () => {
    this.setState({
      isSubmitting: true,
    });
    querySaveBudgetSet({
      uuid: this.props.data.uuid,
      groupUuid: this.props.data.groupUuid,
      groupName: this.props.data.groupName,
      year: this.props.data.year,
    }).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  deleteSet = () => {
    queryDeleteBudgetSet({
      uuid: this.props.data.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <SubmitOp
          data={this.props.data}
          handSubmit={this.handSubmit}
          handleDelete={this.deleteSet}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <FormOpen
          data={dataInfo}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/budget/set/PageEdit.js